module.exports = __webpack_public_path__ + "img/pr-2.e551e77c.png";